module.exports = __webpack_public_path__ + "static/assets/df1cdbb7886c4a3faed089d2a4661935.otf";